// src/pages/Center Admin/CariogramReportEntry.tsx

import React, { useEffect, useState } from "react";

import "../../center admin css/labPickup.css";
import "../../center admin css/centerAdmin.css";

import CariogramActivePatientCard from "../../components/Center Admin/Reuse/CariogramActivePatientCard";

import CariogramQueue from "../../components/Center Admin/Reuse/CariogramQueue";

// ✅ USE YOUR REAL FORM COMPONENT
import CariogramInputForm from "../../components/Center Admin/forms/CariogramInputForm";

import { SidebarItem } from "../../components/Center Admin/layout/CenterAppointmentsQueue";

import api from "../../api/axiosConfig";

const CariogramReportEntry: React.FC = () => {
  const selectedCenter = sessionStorage.getItem("centerId") || "";

  const selectedDate = sessionStorage.getItem("selectedDate") || "";

  // ✅ Selected patient
  const [patient, setPatient] = useState<SidebarItem | null>(null);

  const [queueData, setQueueData] = useState<any>(null);

  const [queueLoading, setQueueLoading] = useState(false);

  const [queueRefreshTrigger, setQueueRefreshTrigger] = useState(0);

  // ✅ Storage key
  const storageKey = "selectedPatient_CARIOGRAM_Q";

  // ✅ Load selected patient
  const loadPatient = () => {
    try {
      const stored = sessionStorage.getItem(storageKey);

      if (stored) {
        const parsed: SidebarItem = JSON.parse(stored);

        setPatient((prev: SidebarItem | null) =>
          JSON.stringify(prev) !== JSON.stringify(parsed) ? parsed : prev,
        );
      } else {
        setPatient(null);
      }
    } catch {
      setPatient(null);
    }
  };

  const handleSubmitSuccess = () => {
    sessionStorage.removeItem("selectedPatient_CARIOGRAM_Q");
    sessionStorage.removeItem("workflowSessionId");

    setPatient(null);

    setQueueRefreshTrigger((prev) => prev + 1);

    window.dispatchEvent(new Event("patientUpdated"));
  };

  useEffect(() => {
    loadPatient();

    const fetchQueue = async () => {
      try {
        setQueueLoading(true);

        const centerId = sessionStorage.getItem("centerId");

        const selectedDate = sessionStorage.getItem("selectedDate");

        if (!centerId || !selectedDate) {
          console.error(
            "[CariogramReportEntry] Missing centerId or selectedDate",
          );
          return;
        }

        const response = await api.centerworkflowApi.get(
          `/queues/CARIOGRAM_INPUT_Q`,
          {
            params: {
              centerId,
              date: selectedDate,
            },
          },
        );

        setQueueData(response.data);

        const waitingPatients = response.data?.waiting || [];

        const storedPatient = sessionStorage.getItem(storageKey);

        if (storedPatient) {
          const parsedPatient = JSON.parse(storedPatient);

          const stillExists = waitingPatients.some(
            (p: any) => p.sessionId === parsedPatient.sessionId,
          );

          if (!stillExists) {
            if (waitingPatients.length > 0) {
              const nextPatient = {
                emrId: waitingPatients[0]?.child?.childId,
                patientName: waitingPatients[0]?.child?.name,
                age: waitingPatients[0]?.child?.age,
                profile: waitingPatients[0]?.child?.profile,
                sessionId: waitingPatients[0]?.sessionId,
              };

              sessionStorage.setItem(storageKey, JSON.stringify(nextPatient));

              setPatient(nextPatient as any);

              window.dispatchEvent(new Event("patientUpdated"));
            } else {
              sessionStorage.removeItem(storageKey);

              setPatient(null);
            }
          }
        }
      } catch (error) {
        console.error("[CariogramReportEntry] Failed to fetch queue:", error);
      } finally {
        setQueueLoading(false);
      }
    };

    fetchQueue();
  }, []);

  // ✅ Sync globally
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === storageKey) {
        loadPatient();
      }
    };

    const handleCustomUpdate = () => {
      loadPatient();
    };

    window.addEventListener("storage", handleStorageChange);

    window.addEventListener("patientUpdated", handleCustomUpdate);

    return () => {
      window.removeEventListener("storage", handleStorageChange);

      window.removeEventListener("patientUpdated", handleCustomUpdate);
    };
  }, []);

  return (
    <div className="center-admin-container">
      {/* ===== LEFT QUEUE ===== */}
      <CariogramQueue
        centerId={selectedCenter}
        selectedDate={selectedDate}
        queueApi="CARIOGRAM_INPUT_Q"
        refreshTrigger={queueRefreshTrigger}
        onSelect={(selectedPatient) => {
          sessionStorage.setItem(
            "selectedPatient_CARIOGRAM_Q",
            JSON.stringify(selectedPatient),
          );

          const patientWithSession = selectedPatient as any;

          if (patientWithSession?.sessionId) {
            sessionStorage.setItem(
              "workflowSessionId",
              patientWithSession.sessionId,
            );
          }

          window.dispatchEvent(new Event("patientUpdated"));
        }}
      />

      {/* ===== RIGHT CONTENT ===== */}
      <div className="center-content">
        {/* ===== Active Patient ===== */}
        <CariogramActivePatientCard patient={patient || undefined} />

        {/* ===== Cariogram Form ===== */}
        <div className="lab-reports-content">
          {patient?.emrId && (
            <div key={patient.emrId}>
              {/* <CariogramInputForm emrId={patient.emrId} submitWorkflow={true} /> */}
              <CariogramInputForm
                emrId={patient.emrId}
                submitWorkflow={true}
                onComplete={handleSubmitSuccess}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CariogramReportEntry;
